"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importNativeBuiltins = exports.defineBuiltin = void 0;
const arithmetic_1 = require("./arithmetic");
const control_1 = require("./control");
const equal_1 = require("./equal");
const macro_1 = require("./macro");
const pair_1 = require("./pair");
const typePredicates_1 = require("./typePredicates");
const defineBuiltin = (frame, name, value) => {
    frame[name] = value;
};
exports.defineBuiltin = defineBuiltin;
const importNativeBuiltins = (context) => {
    const frame = context.runtime.environments[0].head;
    exports.defineBuiltin(frame, '+', arithmetic_1.add);
    exports.defineBuiltin(frame, '-', arithmetic_1.subtract);
    exports.defineBuiltin(frame, '*', arithmetic_1.multiply);
    exports.defineBuiltin(frame, '/', arithmetic_1.divide);
    exports.defineBuiltin(frame, 'quotient', arithmetic_1.quotient);
    exports.defineBuiltin(frame, 'remainder', arithmetic_1.remainder);
    exports.defineBuiltin(frame, 'modulo', arithmetic_1.modulo);
    exports.defineBuiltin(frame, '=', arithmetic_1.numberEqual);
    exports.defineBuiltin(frame, '<', arithmetic_1.lessThan);
    exports.defineBuiltin(frame, '<=', arithmetic_1.lessThanOrEqual);
    exports.defineBuiltin(frame, '>', arithmetic_1.greaterThan);
    exports.defineBuiltin(frame, '>=', arithmetic_1.greaterThanOrEqual);
    exports.defineBuiltin(frame, 'cons', pair_1.cons);
    exports.defineBuiltin(frame, 'car', pair_1.car);
    exports.defineBuiltin(frame, 'cdr', pair_1.cdr);
    exports.defineBuiltin(frame, 'set-car!', pair_1.setCar);
    exports.defineBuiltin(frame, 'set-cdr!', pair_1.setCdr);
    exports.defineBuiltin(frame, 'list', pair_1.list);
    exports.defineBuiltin(frame, 'number?', typePredicates_1.isNumber);
    exports.defineBuiltin(frame, 'boolean?', typePredicates_1.isBool);
    exports.defineBuiltin(frame, 'string?', typePredicates_1.isString);
    exports.defineBuiltin(frame, 'symbol?', typePredicates_1.isSymbol);
    exports.defineBuiltin(frame, 'procedure?', typePredicates_1.isProcedure);
    exports.defineBuiltin(frame, 'pair?', typePredicates_1.isPair);
    exports.defineBuiltin(frame, 'null?', typePredicates_1.isNull);
    exports.defineBuiltin(frame, 'eq?', equal_1.eq);
    exports.defineBuiltin(frame, 'eqv?', equal_1.eqv);
    exports.defineBuiltin(frame, 'equal?', equal_1.equal);
    exports.defineBuiltin(frame, 'apply', control_1.apply);
    exports.defineBuiltin(frame, 'error', control_1.error);
    if (context.variant === 'macro') {
        exports.defineBuiltin(frame, 'macroexpand', macro_1.macroexpand);
        exports.defineBuiltin(frame, 'gensym', macro_1.genSym);
    }
};
exports.importNativeBuiltins = importNativeBuiltins;
//# sourceMappingURL=index.js.map